import React from 'react';
import styles from './Loader.module.css';
import { Logo } from './Logo';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ size = 'medium', showText = true }) => {
  // Map size prop to logo size
  const logoSizes = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16',
  };

  return (
    <div className={`${styles.loaderContainer} ${styles[size]}`}>
      <div className={styles.loader}>
        <div className="animate-spin">
          <Logo className={logoSizes[size]} />
        </div>
        {showText && (
          <span className={styles.loaderText}>AINativeForms</span>
        )}
      </div>
    </div>
  );
};

export default Loader;
